<div class="yelp-setup" *ngIf="preview">
  <div class="yelp-status">
    <ng-icon [name]="'heroInformationCircle'" [size]="'20px'" [strokeWidth]="'2'" [color]="'#6C6176'"
      class="d-block"></ng-icon>
    <span>{{ 'APP.YELP.SETUP.PREVIEW_HINT' | translate }}</span>
  </div>

  <ol class="yelp-steps">
    <li class="yelp-step inactive">
      <span class="yelp-step-number">1</span>
      <div class="yelp-step-body">
        <div class="yelp-step-text">{{ 'APP.YELP.SETUP.STEP_CONNECT_ZAPIER' | translate }}</div>
      </div>
    </li>
    <li class="yelp-step inactive">
      <span class="yelp-step-number">2</span>
      <div class="yelp-step-body">
        <div class="yelp-step-text">{{ 'APP.YELP.SETUP.STEP_CONNECT_YELP' | translate }}</div>
      </div>
    </li>
    <li class="yelp-step inactive">
      <span class="yelp-step-number">3</span>
      <div class="yelp-step-body">
        <div class="yelp-step-text">{{ 'APP.YELP.SETUP.STEP_TURN_ON_ZAPS' | translate }}</div>
      </div>
    </li>
  </ol>
</div>

<div class="yelp-setup" *ngIf="!preview">
  <div class="yelp-status" [class.connected]="!!app?.config?.lastMessageOn">
    <ng-icon [name]="app?.config?.lastMessageOn ? 'heroCheckCircle' : 'heroInformationCircle'" [size]="'20px'"
      [strokeWidth]="'2'" [color]="app?.config?.lastMessageOn ? '#059669' : '#6C6176'" class="d-block"></ng-icon>
    <span>{{ (app?.config?.lastMessageOn ? 'APP.YELP.SETUP.STATUS_CONNECTED' : 'APP.YELP.SETUP.STATUS_WAITING') |
      translate:{date: app?.config?.lastMessageOn} }}</span>
  </div>

  <ol class="yelp-steps" *ngIf="!showManualSetup" [shimmer]="isLoading">
    <li class="yelp-step" [class.done]="isZapierConnected">
      <span class="yelp-step-number">
        <ng-icon *ngIf="isZapierConnected" name="heroCheck" size="14px" strokeWidth="3"></ng-icon>
        <ng-container *ngIf="!isZapierConnected">1</ng-container>
      </span>
      <div class="yelp-step-body">
        <div class="yelp-step-text">
          {{ (isZapierConnected ? 'APP.YELP.SETUP.ZAPIER_CONNECTED' : 'APP.YELP.SETUP.STEP_CONNECT_ZAPIER') | translate }}
        </div>
        <rosie-button *ngIf="!isZapierConnected" (click)="connectZapier()" [customClass]="'slimmish narrow text-sm'"
          [fullWidth]="false" [inProgress]="isConnectingZapier" [disabled]="isLoading || isConnectingZapier"
          [translationKey]="'APP.YELP.SETUP.CONNECT_ZAPIER'"></rosie-button>
        <button *ngIf="isZapierConnected" type="button" class="yelp-link" (click)="disconnectZapier()">
          {{ 'APP.YELP.SETUP.DISCONNECT_ZAPIER' | translate }}
        </button>
      </div>
    </li>

    <li class="yelp-step" [class.done]="hasYelpAccount" [class.inactive]="!isZapierConnected">
      <span class="yelp-step-number">
        <ng-icon *ngIf="hasYelpAccount" name="heroCheck" size="14px" strokeWidth="3"></ng-icon>
        <ng-container *ngIf="!hasYelpAccount">2</ng-container>
      </span>
      <div class="yelp-step-body">
        <ng-container *ngIf="!hasYelpAccount">
          <div class="yelp-step-text">{{ 'APP.YELP.SETUP.STEP_CONNECT_YELP' | translate }}</div>
          <rosie-button *ngIf="isZapierConnected" (click)="connectYelp()" [customClass]="'slimmish narrow text-sm'"
            [fullWidth]="false" [inProgress]="isWaitingForYelp" [disabled]="isWaitingForYelp || !setup?.yelpConnectUrl"
            [translationKey]="'APP.YELP.SETUP.CONNECT_YELP'"></rosie-button>
          <div class="yelp-step-hint" *ngIf="isWaitingForYelp">{{ 'APP.YELP.SETUP.WAITING_FOR_YELP' | translate }}</div>
        </ng-container>
        <ng-container *ngIf="hasYelpAccount">
          <div class="yelp-step-text" *ngIf="yelpAccountOptions.length === 1">
            {{ 'APP.YELP.SETUP.YELP_CONNECTED' | translate:{account: selectedYelpAccountTitle} }}
          </div>
          <ng-container *ngIf="yelpAccountOptions.length > 1">
            <div class="yelp-step-text">{{ 'APP.YELP.SETUP.CHOOSE_YELP_ACCOUNT' | translate }}</div>
            <rosie-select-input class="yelp-select" [control]="yelpAccountControl" [options]="yelpAccountOptions"
              [placeholderTranslationKey]="'APP.YELP.SETUP.YELP_ACCOUNT'"></rosie-select-input>
          </ng-container>
        </ng-container>
      </div>
    </li>

    <li class="yelp-step" [class.done]="areAllZapsOn" [class.inactive]="!hasYelpAccount">
      <span class="yelp-step-number">
        <ng-icon *ngIf="areAllZapsOn" name="heroCheck" size="14px" strokeWidth="3"></ng-icon>
        <ng-container *ngIf="!areAllZapsOn">3</ng-container>
      </span>
      <div class="yelp-step-body">
        <div class="yelp-step-text">{{ 'APP.YELP.SETUP.STEP_TURN_ON_ZAPS' | translate }}</div>
        <ng-container *ngIf="hasYelpAccount">
          <rosie-select-input *ngIf="yelpBusinessOptions.length > 1" class="yelp-select" [control]="yelpBusinessControl"
            [options]="yelpBusinessOptions" [placeholderTranslationKey]="'APP.YELP.SETUP.CHOOSE_YELP_BUSINESS'"></rosie-select-input>
          <ul class="yelp-zaps" *ngIf="zaps.length > 0">
            <li class="yelp-zap" *ngFor="let zap of zaps">
              <span class="yelp-zap-dot" [class.on]="zap.isEnabled"></span>
              <span class="yelp-zap-name">{{ zapTranslationKey(zap) | translate }}</span>
              <span class="yelp-zap-state">
                {{ (zap.isEnabled ? 'APP.YELP.SETUP.ZAP_ON' : 'APP.YELP.SETUP.ZAP_OFF') | translate }} ·
                {{ zap.lastSuccessfulRunAt ? ('APP.YELP.SETUP.ZAP_LAST_RUN' | translate:{date: zap.lastSuccessfulRunAt}) : ('APP.YELP.SETUP.ZAP_NO_RUNS' | translate) }}
              </span>
              <button *ngIf="zap.editorUrl" type="button" class="yelp-link" (click)="openZap(zap)">
                {{ 'APP.YELP.SETUP.OPEN_IN_ZAPIER' | translate }}
              </button>
            </li>
          </ul>
          <rosie-button *ngIf="!areAllZapsOn" (click)="turnOn()" [customClass]="'slimmish narrow text-sm'"
            [fullWidth]="false" [inProgress]="isTurningOn" [disabled]="!canTurnOn"
            [translationKey]="turnOnTranslationKey"></rosie-button>
        </ng-container>
      </div>
    </li>
  </ol>

  <ol class="yelp-steps" *ngIf="showManualSetup">
    <li class="yelp-step">
      <span class="yelp-step-number">1</span>
      <div class="yelp-step-body">
        <div class="yelp-step-text">{{ 'APP.YELP.SETUP.STEP_COPY_KEY' | translate }}</div>
        <div class="yelp-key" [shimmer]="!app?.config?.apiKey">
          <code>{{ app?.config?.apiKey }}</code>
          <rosie-button (click)="copyApiKey()" [customClass]="'action slimmish narrow text-sm'"
            [fullWidth]="false"
            [iconPrefixConfig]="{name: copiedApiKey ? 'heroCheck' : 'heroSquare2Stack', size: '16px', strokeWidth: '2', color: '#822ac6'}"
            [translationKey]="copiedApiKey ? 'COMMON.COPIED' : 'COMMON.COPY'"></rosie-button>
        </div>
      </div>
    </li>
    <li class="yelp-step">
      <span class="yelp-step-number">2</span>
      <div class="yelp-step-body">
        <div class="yelp-step-text">{{ 'APP.YELP.SETUP.STEP_OPEN_ZAPIER' | translate }}</div>
        <rosie-button (click)="openYelpZap()" [customClass]="'secondary slimmish narrow text-sm'"
          [fullWidth]="false"
          [iconSuffixConfig]="{name: 'heroArrowUpRight', size: '16px', strokeWidth: '2', color: '#6C6176'}"
          [translationKey]="'APP.YELP.SETUP.OPEN_ZAPIER'"></rosie-button>
      </div>
    </li>
    <li class="yelp-step">
      <span class="yelp-step-number">3</span>
      <div class="yelp-step-body">
        <div class="yelp-step-text">{{ 'APP.YELP.SETUP.STEP_CONNECT' | translate }}</div>
      </div>
    </li>
    <li class="yelp-step">
      <span class="yelp-step-number">4</span>
      <div class="yelp-step-body">
        <div class="yelp-step-text">{{ 'APP.YELP.SETUP.STEP_TURN_ON' | translate }}</div>
      </div>
    </li>
  </ol>

  <button type="button" class="yelp-link yelp-manual-toggle" (click)="showManualSetup = !showManualSetup">
    {{ (showManualSetup ? 'APP.YELP.SETUP.MANUAL_HIDE' : 'APP.YELP.SETUP.MANUAL_SHOW') | translate }}
  </button>
</div>
